export class Stage3 {
    validate() {
        // return [
        //     'company_name',
        //     'business_type',
        //     'company_phone',
        //     'company_email',
        //     'address_line_1',
        //     'address_line_2',
        //     'post_code',
        //     'country',
        // ];
        
        // delegateDetails
        let dds = Alpine.store('status').currentDelegate().company_details;
        
        
        return (
            (typeof dds.company_name !== 'undefined' && dds.company_name.length > 0) &&
            (typeof dds.business_type !== 'undefined' && dds.business_type.length > 0) &&
            (typeof dds.company_phone !== 'undefined' && dds.company_phone.length > 0) &&
            (typeof dds.company_email !== 'undefined' && dds.company_email.length > 0) &&
            (typeof dds.address_line_1 !== 'undefined' && dds.address_line_1.length > 0) &&
            (typeof dds.address_line_2 !== 'undefined' && dds.address_line_2.length > 0) &&
            (typeof dds.post_code !== 'undefined' && dds.post_code.length > 0) &&
            (typeof dds.country !== 'undefined' && dds.country.length > 0)
        );
    }
}